import { render } from "./MiniStatisticsCard.vue?vue&type=template&id=a9207432&scoped=true"
import script from "./MiniStatisticsCard.vue?vue&type=script&lang=js"
export * from "./MiniStatisticsCard.vue?vue&type=script&lang=js"

import "./MiniStatisticsCard.vue?vue&type=style&index=0&id=a9207432&scoped=true&lang=css"

import exportComponent from "/var/www/html/fms_employee_Portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9207432"]])

export default __exports__